var map = {
	"./ApplyNowWidget.vue": "c107",
	"./ArticlesListWidget.vue": "5ab5",
	"./BaseWidgetForm.vue": "306b",
	"./BoxesWidget.vue": "2daf",
	"./CirclesWidget.vue": "aa22",
	"./FAQWidget.vue": "2af2",
	"./FaqLinkWidget.vue": "b75f",
	"./GlossaryWidget.vue": "94f3",
	"./GreenLinkWidget.vue": "f2e2",
	"./ImageWidget.vue": "a62d",
	"./KeypointsWidget.vue": "480a",
	"./LogotypesWidget.vue": "45d3",
	"./QuotationWidget.vue": "8824",
	"./TextWidget.vue": "ce64",
	"./TextWithTitleWidget.vue": "8aba",
	"./TitleWidget.vue": "71a8",
	"./UnderlineWidget.vue": "0879",
	"./VideoWidget.vue": "733b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7e1";